import React, { useEffect, useRef } from 'react';
import {Trans, useTranslation } from 'react-i18next';

import './AboutSection.css';
import award1 from '../../../assets/food-travel-2023.png';
import award2 from '../../../assets/TripAdvisorAbout.png';

const AboutSection: React.FC = () => {
  const { t } = useTranslation();
  
  const textRefs = useRef<HTMLDivElement[]>([]);
  const awardsRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add('af-visible');
          }
        });
      },
      { threshold: 0.3 }
    );

    textRefs.current.forEach((el) => {
      if (el) observer.observe(el);
    });

    if (awardsRef.current) observer.observe(awardsRef.current);

    return () => {
      textRefs.current.forEach((el) => {
        if (el) observer.unobserve(el);
      });

      if (awardsRef.current) observer.unobserve(awardsRef.current);
    };
  }, []);

  const setTextRef = (el: HTMLDivElement | null, index: number) => {
    if (el) textRefs.current[index] = el;
  };

  return (
    <section className="af-about-section">
      <div className="af-about-content">
        <div className="af-text-column">
          <div className="af-animated-item" ref={(el) => setTextRef(el, 0)}>
            <h2>{t('about:title')}</h2>
          </div>

          <div className="af-animated-item" ref={(el) => setTextRef(el, 1)}>
           <p><Trans i18nKey="about:p1" /></p>
          </div>

          <div className="af-animated-item" ref={(el) => setTextRef(el, 2)}>
            <p><Trans i18nKey="about:p2" /></p>
          </div>

          <div className="af-animated-item" ref={(el) => setTextRef(el, 3)}>
            <p><Trans i18nKey="about:p3" /></p>
          </div>
        </div>

        <div className="af-awards-column af-animated-item" ref={awardsRef}>
          <img src={award1} alt="Food and Travel 2023 Award" className="af-award-logo af-award-logo-1" />
          <img src={award2} alt="TripAdvisor Travelers' Choice 2025" className="af-award-logo af-award-logo-1" />
        </div>
      </div>
    </section>
  );
};

export default AboutSection;
